export default {
      id: "illustration-shopping-cart-usage",
      viewBox: "0 0 120 121",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#illustration-shopping-cart",
      toString: function () {
        return this.url;
      }
    }